import { Trans } from '@lingui/react/macro'
import { useCallback, useId, useState } from 'react'
import Button from 'react-bootstrap/Button'
import Col from 'react-bootstrap/Col'
import Collapse from 'react-bootstrap/Collapse'
import Fade from 'react-bootstrap/Fade'
import Row from 'react-bootstrap/Row'

export default function CollapsableForm({
  onApply,
  onReset,
  children,
  defaultVisible = false,
  buttonsOnNewLine = false,
}) {
  const id = useId()
  const [visible, setVisibility] = useState(defaultVisible)

  const toggleVisibility = useCallback(() => {
    setVisibility((prevVisibility) => !prevVisibility)
  })

  return (
    <>
      <Button variant='default' onClick={toggleVisibility} aria-controls={id} aria-expanded={visible}>
        {visible ? <Trans>Hide filters</Trans> : <Trans>Show filters</Trans>}
      </Button>
      <Collapse mountOnEnter unmountOnExit in={visible}>
        {/* a <div> wrapper is required for the animation to run smoothly */}
        <div>
          <Fade mountOnEnter in={visible}>
            <form id={id} className='my-2'>
              <Row xs={1} md={3} className='gy-2 align-items-end'>
                {children}
                {!buttonsOnNewLine && (
                  <Col>
                    <button type='button' className='btn btn-primary' onClick={onApply}>
                      <Trans>Apply</Trans>
                    </button>
                    <button type='button' className='ms-2 btn btn-default' onClick={onReset}>
                      <Trans>Reset</Trans>
                    </button>
                  </Col>
                )}
              </Row>
              {buttonsOnNewLine && (
                <Row className='mt-3'>
                  <Col>
                    <button type='button' className='btn btn-primary' onClick={onApply}>
                      <Trans>Apply</Trans>
                    </button>
                    <button type='button' className='ms-2 btn btn-default' onClick={onReset}>
                      <Trans>Reset</Trans>
                    </button>
                  </Col>
                </Row>
              )}
            </form>
          </Fade>
        </div>
      </Collapse>
    </>
  )
}
